<template>
  <div class="init-login-wrapper">
    <div class="init-login-content">
      <div class="init-login-logo">
        <img src="../assets/images/init-logo.png" alt="" />
      </div>
      <h2 class="init-login-title">修改初始密码</h2>
      <p class="init-login-mess">
        为保障您的账户及内部数据安全，防止信息泄露，您需要修改初始密码后才可登录
      </p>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="setPassWord">
          <el-input
            maxlength="16"
            minlength="6"
            class="init-login-input"
            placeholder="设置新密码，6-16位的字母或数字组合"
            v-model="ruleForm.setPassWord"
          ></el-input>
        </el-form-item>
        <el-form-item prop="surePassWord">
          <el-input
            maxlength="16"
            minlength="6" 
            class="init-login-input"
            type="password"
            placeholder="验证新密码"
            v-model="ruleForm.surePassWord"
          ></el-input>
        </el-form-item>
        <el-form-item class="sure-login">
          <el-button :disabled="disabled" @click="initSubmit"
            >确定并登录</el-button
          >
        </el-form-item>
      </el-form>
      <p class="next-change" v-if="+needForce === 0" @click="onNext">下次再改</p>
    </div>
  </div>
</template>

<script>
import Http from "../lib/Http";

export default {
  name: "InitPassWord",
  data() {
    var validatePass = (rule, value, callback) => {
      //验证密码
      // let reg = /[^\u00-\uFF]/;
      if (value === "") {
        callback(new Error("请输入密码"));
        // this.disabled = true
      }else if (value.length < 6) {
        callback(new Error("密码太短"));
      }else if(this.pass) {
        this.pass = 0;
        callback(new Error(this.passErr));
      } else {
        if (this.ruleForm.surePassWord !== "") {
          this.$refs.ruleForm.validateField("surePassWord");
        }
        // this.disabled = false
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      //二次验证密码
      if (value === "") {
        callback(new Error("请再次输入密码"));
        this.disabled = true;
      } else if (value !== this.ruleForm.setPassWord) {
        callback(new Error("两次输入密码不一致!"));
        this.disabled = true;
      } else if (value.length < 6) {
        callback(new Error("密码太短"));
        this.disabled = true;
      } else {
        this.disabled = false;
        callback();
      }
    };
    return {
      disabled: true,
      rules: {
        setPassWord: [{ validator: validatePass, trigger: "blur" }],
        surePassWord: [{ validator: validatePass2, trigger: "blur" }],
      },
      ruleForm: {
        setPassWord: "",
        surePassWord: "",
      },
      pass: 0,
      passErr: "",
      needForce: "",
      updateToken: "",
      portalToken: "",
    };
  },
  created() {
    this.needSession(1);
  },
  activated() {
    this.needSession(1);
    this.ruleForm.setPassWord = "";
    this.ruleForm.surePassWord = "";
    this.$nextTick(() => {
      this.$refs.ruleForm.clearValidate();
    });
  },
  methods: {
    needSession(val) {
      if (val) {
        this.needForce = sessionStorage.getItem("forceUpdate");
        this.updateToken = sessionStorage.getItem("updateToken");
        this.portalToken = sessionStorage.getItem("portalToken");
      } else {
        sessionStorage.removeItem("forceUpdate");
        sessionStorage.removeItem("updateToken");
        sessionStorage.removeItem("portalToken");
      }
    },
    onNext() {
      if (+this.needForce) return;
      // this.needSession(0);
      window.location.href = `${Http.JUMP_TEACHER_URL().hm}/?portal=${this.portalToken}`
    },
    initSubmit() {
      let sendObj = {
        clientType: 1,
        password: this.ruleForm.setPassWord,
        confirm: this.ruleForm.surePassWord,
        updateToken: this.updateToken,
      };
      let _this = this;
      if (this.$route.query.from === "teacher") {
        Http.zsyPutHttp(
          "/auth/teacher/change/password",
          sendObj,
          (ok) => {
            window.location.href = `${Http.JUMP_TEACHER_URL().hm}/?portal=${ok.data.loginToken}`
          },
          (fail) => { 
            console.log(fail);
            if (fail.errMsg == "新密码太简单，请更换安全的密码！") {
              _this.pass = 1;
              _this.passErr = "新密码太简单"
              _this.$nextTick(() => {
                _this.$refs.ruleForm.validateField("setPassWord");
              });
            } else if (fail.errMsg == "授权已超时，请重新开始验证！") {
              this.$message.error("授权已超时，请重新开始验证！");
              setTimeout(() => {
                _this.needSession(0);
                _this.$router.push("/");
              }, 2000);
            }else if(fail.errMsg == "密码格式错误:密码位数6~16位，只能数字和字母组合。") {
              _this.pass = 1;
              _this.passErr = "密码格式错误"
              _this.$nextTick(() => {
                _this.$refs.ruleForm.validateField("setPassWord");
              });
            }
          }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.init-login-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url("../assets/images/bg-main.png") top;
  .init-login-logo {
    width: 148px;
    height: 148px;
    border-radius: 50%;
    background: #ffffff;
    position: absolute;
    top: -74px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .init-login-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 4px;
    width: 600px;
    padding: 90px 120px 60px 120px;
    box-sizing: border-box;
    .init-login-title {
      font-size: 30px;
      color: #333333;
      text-align: center;
      font-weight: 400;
    }
    .init-login-mess {
      font-size: 12px;
      color: #363636;
      font-weight: 400;
      margin: 30px 0 40px 0;
    }
    .init-login-input {
      /deep/ .el-input__inner {
        border-left: 0; // 去除未选中状态边框
        border-right: 0; // 去除未选中状态边框
        border-top: 0;
        border-bottom: 1px solid #eeeeee;
        outline: none; // 去除选中状态边框
        border-radius: 0;
        // background-color: rgba(0, 0, 0, 0); // 透明背景
      }
    }
  }
  .next-change {
    text-align: right;
    cursor: pointer;
    &:hover {
      color: #3ecdba;
    }
  }
  .sure-login {
    /deep/ .el-form-item__content {
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// InitPassWord.vue?0692c67a